import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'

import guess from './modules/guess'
import { getTrySeeCache } from '@/commons/utils'
// import home from './modules/home'

if (process.env.NODE_ENV === 'development') {
  Vue.use(Vuex)
}
/**
 * 全局公用的state放这里
 * 如果是部分页面或模块独有的state放modules里
 */
const state = {
  // 用户数据
  user: {},
  // 一些功能的配置
  options: {},
  isMobile: false,
  isLive: false,
  isFetchAppUserData: false,
  channelLiveState: {},
  liveUrl: '',
  liveType: '',
  liveInfo: {},
  posterUrl: '',
  chatReadyState: false,
  serverTime: null,
  prevueTime: null,
  emcee: null,
  tradingVideoID: '',
  videoID: '',
  // 后续优化，分离
  fmLivePlayState: true,
  fmReplayState: false,
  fmVideo: {
    isShow: false,
    url: ''
  },
  fmEmmecNotice: '',
  isShowFMSign: false,

  weekTalkDatas: {},

  pageType: '',
  // 精英会员
  isEliteVip: false,
  // 钻石会员
  isVip: false,
  // 黑金会员
  isBlackGoldVip: false,
  // 年会员
  isYearVip: false,
  // 超级会员
  isSuperVip: false,
  hasGetUser: false,
  hasGetOptions: false,

  /** 试看直播列表 */
  trySeeRemain: getTrySeeCache(),

  serviceQRCodeConfig: [],
  localTime: Date.now(),
  // 顶部菜单栏
  topNavs: [],
  windowWidth: window.innerWidth,
  hasBuyDing: false,
  hasGetDingInfo: false,
  hasGetDingShowConfig: false,
  dingShowConfig: {
    roomName: '',
    show: false
  },
  chatRooms: {}
}

export default new Vuex.Store({
  state,
  actions,
  getters,
  mutations,
  modules: {
    // home
    guess
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js